import { Controller } from "@hotwired/stimulus"

// Toggles between three states inside the appointment slide-over:
//   "idle"         — Complete / No-Show / Reschedule / Cancel buttons visible
//                    (actions target), Session Note section visible (noteSection
//                    target).
//   "rescheduling" — date+time form visible (form target). Idle hidden.
//   "cancelling"   — cancel form visible (cancelForm target). Idle hidden.
//
// All targets exist in the DOM at all times; we just toggle the `hidden` class.
//
// Conflict-check updates are handled by the standalone `conflict-check`
// controller composed alongside this one on the slide-over wrapper.
export default class extends Controller {
  static targets = ["actions", "form", "datetime", "noteSection", "cancelForm"]

  show() {
    this.hideIdle()
    this.formTarget.classList.remove("hidden")
    if (this.hasDatetimeTarget) this.datetimeTarget.focus()
  }

  hide() {
    this.formTarget.classList.add("hidden")
    this.showIdle()
  }

  showCancel() {
    this.hideIdle()
    this.cancelFormTarget.classList.remove("hidden")
  }

  hideCancel() {
    this.cancelFormTarget.classList.add("hidden")
    this.showIdle()
  }

  hideIdle() {
    this.actionsTarget.classList.add("hidden")
    if (this.hasNoteSectionTarget) this.noteSectionTarget.classList.add("hidden")
  }

  showIdle() {
    this.actionsTarget.classList.remove("hidden")
    if (this.hasNoteSectionTarget) this.noteSectionTarget.classList.remove("hidden")
  }
}
